import React from 'react'

import PixKeyForm from './pix-key-form'
import { ErrorIconStyled, PixErrorContainer, PixValueSubTitle } from './styles' //

const PixErrorSection = ({ value, cancellationId, onPixUpdated, cancellationData }) => {
  return (
    <>
      <PixValueSubTitle>
        <strong>Valor: </strong>
        R$ {value}
      </PixValueSubTitle>
      <PixErrorContainer>
        <ErrorIconStyled />
        Não conseguimos concluir a operação por conta de uma falha nos dados de pagamento. Para que possamos finalizar o
        processo, atualize a chave PIX.
      </PixErrorContainer>
      <PixKeyForm cancellationId={cancellationId} onPixUpdated={onPixUpdated} cancellationData={cancellationData} />
    </>
  )
}

export default PixErrorSection
